const DocumentationSection: React.FC = () => {
  return (
    <>
      <p>Documentation coming soon..</p>
    </>
  );
};
export default DocumentationSection;
